import React, { type PropsWithChildren, useContext } from "react";

import { SupTabList } from "./components/TabList";
import { SupScrollableTabList } from "./components/ScrollableTabList";
import { TabContext } from "./TabContext";

export interface TabListProps extends PropsWithChildren {
  value?: string | number;
  scrollable?: boolean;
  onChange?: (value: string | number) => void;
  orientation?: "horizontal" | "vertical";
  indicatorPosition?: "top" | "bottom" | "left" | "right";
  className?: string;
}

export function SupTabs({ value, scrollable = false, onChange, ...restProps }: TabListProps) {
  const { activeTab, setActiveTab } = useContext(TabContext);
  const currentValue = value ?? activeTab;

  const handleClick = (tab: string | number) => {
    setActiveTab?.(tab);
    onChange?.(tab);
  };

  return scrollable ? (
    <SupScrollableTabList value={currentValue} onChange={handleClick} {...restProps} />
  ) : (
    <SupTabList value={currentValue} onChange={handleClick} {...restProps} />
  );
}
